import { Brightness1 } from "@mui/icons-material";

import { connect, ConnectedProps } from "react-redux";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { IStore } from "../../../store/IStore";
import { CircleDto } from "../../../store/models/circle/CircleDto";
import { KNISTR_GREEN } from "../../atoms/ImsMaterialTheme";
import { ImsHeadCell, ImsTable, ImsTableRow } from "../../atoms/ImsTable";
import CircleTableMenu from "./CircleTableMenu";
import { useTranslation } from "react-i18next";

const CircleTable = (props: ThunkProps) => {
  const { circles } = props;
  const { t } = useTranslation();
  const headCells: ImsHeadCell<CircleDto>[] = [
    { val: (val) => val.circleExternalNumber, node: t("setup.headlineCircleId") },
    { val: (val) => val.circleName, node: t("setup.headlineDesignation") },
    { val: (val) => val.defaultCircle, node: t("setup.headlineStandard") },
  ];

  const rows: ImsTableRow<CircleDto>[] = circles.map((row) => ({
    value: row,
    nodes: [
      row.circleExternalNumber,
      row.circleName,
      row.defaultCircle && (
        <Brightness1
          style={{
            fill: KNISTR_GREEN,
            paddingTop: 4,
          }}
        />
      ),
      <CircleTableMenu circle={row} />,
    ],
  }));
  return rows.length ? (
    <ImsTable hasMenu={true} headCells={headCells} rows={rows} sortColumnIndex={1} sortDirection="desc" />
  ) : (
    <>{t("setup.noData")}</>
  );
};

const mapStateToProps = (state: IStore) => ({
  circles: state.circles.circles,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => bindActionCreators({}, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);
type ThunkProps = ConnectedProps<typeof connector>;
export default connector(CircleTable);
